import { DeleteOutlined } from '@ant-design/icons';
import { Button, Input, Modal, message, Form } from 'antd';
import React, { useEffect, useState } from 'react';
// import { Form } from '@ant-design/compatible';
import { isValidUrl } from 'utils/utils';

const ProxyUrlModal = ({
  proxyUrlModal,
  setProxyUrlModal,
  skill,
  updateSkill,
  currentSkill,
}) => {
  const [proxyUrl, setProxyUrl] = useState('');
  const [proxyUrlErrors, setProxyUrlErrors] = useState({
    isProxyUrlEmpty: false,
    urlExists: false,
    invalidUrl: false,
  });
  const [proxyUrlList, setProxyUrlList] = useState([]);

  const hasError =
    proxyUrlList.length &&
    proxyUrlList.some(
      (proxyUrl) =>
        !proxyUrl.url || proxyUrl.existError || proxyUrl.invalidError
    );

  useEffect(() => {
    const proxyUrlsList = skill.skill_metadata
      ? skill.skill_metadata.metadata.proxy_url_list
      : skill.metadata.proxy_url_list
      ? skill.metadata.proxy_url_list
      : [];
    setProxyUrlList(proxyUrlsList);
  }, []);

  const isURLInArray = (url, urlArray) => {
    let lowercasedURL = url.toLowerCase();

    for (let i = 0; i < urlArray.length; i++) {
      const urlFromArray = urlArray[i].url;
      // Check for protocol difference and match without the protocol
      if (
        lowercasedURL.startsWith('http://') &&
        urlFromArray.startsWith('https://')
      ) {
        lowercasedURL = 'https://' + lowercasedURL.substring(7);
      } else if (
        lowercasedURL.startsWith('https://') &&
        urlFromArray.startsWith('http://')
      ) {
        lowercasedURL = 'http://' + lowercasedURL.substring(8);
      }

      if (lowercasedURL.startsWith(urlFromArray.toLowerCase())) {
        return true;
      }
    }

    return false;
  };

  const changeProxyUrl = (e) => {
    const urlExists = isURLInArray(e.target.value.trim(), proxyUrlList);
    setProxyUrl(e.target.value);
    setProxyUrlErrors({
      urlExists: urlExists ? true : false,
      isProxyUrlEmpty: false,
      invalidUrl: false,
    });
  };

  const addHttpsToURL = (url) => {
    if (!url.startsWith('https://') && !url.startsWith('http://')) {
      url = 'https://' + url;
    }
    return url;
  };

  const handleAddProxyUrl = () => {
    const trimmedUrl = addHttpsToURL(proxyUrl.trim());
    if (trimmedUrl === '') {
      setProxyUrlErrors({
        urlExists: false,
        isProxyUrlEmpty: true,
        invalidUrl: false,
      });
    } else {
      const urlExists = isURLInArray(trimmedUrl, proxyUrlList);
      if (urlExists) {
        setProxyUrlErrors({
          urlExists: true,
          isProxyUrlEmpty: false,
          invalidUrl: false,
        });
      } else if (!isValidUrl(trimmedUrl)) {
        setProxyUrlErrors({
          urlExists: false,
          isProxyUrlEmpty: false,
          invalidUrl: true,
        });
      } else {
        setProxyUrlList([
          ...proxyUrlList,
          { url: trimmedUrl, existError: false, invalidError: false },
        ]);
        setProxyUrl('');
      }
    }
  };

  const handleUpdateProxyUrl = (index, value) => {
    const trimmedUrl = addHttpsToURL(value.trim());
    const updatedList = [...proxyUrlList];
    const urlExists = updatedList.find((val) => val.url === trimmedUrl);

    if (!isValidUrl(trimmedUrl)) {
      updatedList[index] = {
        url: trimmedUrl,
        invalidError: true,
        existError: false,
      };
      setProxyUrlList(updatedList);
    } else if (urlExists) {
      updatedList[index] = {
        url: trimmedUrl,
        invalidError: false,
        existError: true,
      };
      setProxyUrlList(updatedList);
    } else {
      updatedList[index] = {
        url: trimmedUrl,
        invalidError: false,
        existError: false,
      };
      setProxyUrlList(updatedList);

      const newUrlExists = isURLInArray(proxyUrl.trim(), updatedList);
      setProxyUrlErrors({
        urlExists: newUrlExists,
        isProxyUrlEmpty: false,
        invalidUrl: false,
      });
    }
  };

  const handleDeleteProxyUrl = (url) => {
    const updatedArray = proxyUrlList.filter((item) => item.url !== url);
    const urlExists = isURLInArray(url, updatedArray);
    setProxyUrlList(updatedArray);
    setProxyUrlErrors({
      urlExists: urlExists,
      isProxyUrlEmpty: false,
      invalidUrl: false,
    });
  };

  const handleCloseProxyModal = () => {
    const proxyUrlsList = skill.skill_metadata
      ? skill.skill_metadata.metadata.proxy_url_list
      : skill.metadata.proxy_url_list
      ? skill.metadata.proxy_url_list
      : [];

    setProxyUrlModal(false);
    setProxyUrl('');
    setProxyUrlErrors({
      isProxyUrlEmpty: false,
      urlExists: false,
      invalidUrl: false,
    });
    setProxyUrlList(proxyUrlsList);
  };

  const handleSubmitProxyUrl = () => {
    const urlList = proxyUrlList.map((item) => {
      return { url: item.url };
    });
    const obj = { 'metadata.proxy_url_list': urlList };
    const skillId =
      skill && skill.skill_metadata ? skill.skill_metadata._id : skill._id;
    const wId =
      skill && skill.skill_metadata
        ? skill.skill_metadata.workspace_id
        : skill.workspace_id;
    updateSkill(skillId, wId, obj, currentSkill).then((res) => {
      if (res.data.success) {
        setProxyUrlModal(false);
        message.success("Proxy URL's updated successfully");
      }
    });
  };
  return (
    <Modal
      title={'Update Proxy URL'}
      visible={proxyUrlModal}
      onCancel={handleCloseProxyModal}
      onOk={handleSubmitProxyUrl}
      okText='Submit'
      cancelText='Close'
      okButtonProps={{ disabled: hasError }}>
      <Form layout='vertical'>
        <div
          style={{
            display: 'flex',
            gap: '8px',
            marginBottom: '8px',
          }}>
          <Form.Item
            className={
              localStorage.getItem('theme') == 'dark' && 'form_label_dark'
            }
            style={{ margin: 0, padding: 0, width: '100%' }}
            validateStatus={
              proxyUrlErrors.isProxyUrlEmpty ||
              proxyUrlErrors.urlExists ||
              proxyUrlErrors.invalidUrl
                ? 'error'
                : ''
            }
            help={
              proxyUrlErrors.isProxyUrlEmpty
                ? 'Please enter a URL'
                : proxyUrlErrors.urlExists
                ? 'URL already exists'
                : proxyUrlErrors.invalidUrl
                ? 'Please enter a valid URL'
                : ''
            }>
            <Input
              type='url'
              placeholder='Enter URL'
              onChange={changeProxyUrl}
              value={proxyUrl}
              name='proxyUrl'
              className={` input-bg ${
                localStorage.getItem('theme') == 'dark' && 'autofill_dark'
              }`}
            />
          </Form.Item>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              handleAddProxyUrl();
            }}>
            Add
          </Button>
        </div>

        {proxyUrlList.length ? (
          proxyUrlList.map((value, index) => (
            <div
              key={value.url}
              style={{
                display: 'flex',
                gap: '8px',
                marginBottom: '8px',
              }}>
              <Form.Item
                className={
                  localStorage.getItem('theme') == 'dark' && 'form_label_dark'
                }
                style={{ margin: 0, padding: 0, width: '100%' }}
                validateStatus={
                  value.url === '' || value.invalidError || value.existError
                    ? 'error'
                    : ''
                }
                help={
                  value.url === ''
                    ? 'Please enter a URL'
                    : value.existError
                    ? 'URL already exists'
                    : value.invalidError
                    ? 'Please enter a valid URL'
                    : ''
                }>
                <Input
                  type='url'
                  placeholder='Enter URL'
                  defaultValue={value.url}
                  onBlur={(e) => {
                    const newValue = e.target.value.trim();
                    if (newValue !== value.url) {
                      handleUpdateProxyUrl(index, newValue);
                    }
                  }}
                  name='proxyUrl'
                  className={` input-bg ${
                    localStorage.getItem('theme') == 'dark' && 'autofill_dark'
                  }`}
                />
              </Form.Item>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteProxyUrl(value.url);
                }}
                type='text'
                icon={<DeleteOutlined />}
              />
            </div>
          ))
        ) : (
          <></>
        )}
      </Form>
    </Modal>
  );
};

export default ProxyUrlModal;
